import throttle from 'lodash.throttle';

const openSocialShare = () => (document.querySelector('body').classList.contains('open-social') ? document.querySelector('body').classList.remove('open-social') : document.querySelector('body').classList.add('open-social'));

const test = () => {
  const footerHeight = document.querySelector('footer').offsetHeight;

  if ((window.innerHeight + window.scrollY) > (document.body.scrollHeight - footerHeight)) {
    return document.querySelector('.cp-share-social').classList.add('hide');
  }
  return document.querySelector('.cp-share-social').classList.remove('hide');
};

export default function initSocialShare() {
  const $social = document.querySelector('.cp-share-social');
  if (!$social) {
    return;
  }

  const btnSocial = $social.querySelector('.js-btn-open-social');

  btnSocial.addEventListener('click', openSocialShare);

  window.addEventListener('scroll', throttle(() => {
    test();
  }, 250));
}
